import React from "react";

export const newsItems = [
  {
    image: 'NewsImages/turningPoint.png',
    title: 'Byline on 2026 Trends - Kyle Rolfing',
    alt: 'Healthcare Business Today article thumbnail: Byline on 2026 Employer Health Plan Innovation Trends',
    source: 'Healthcare Business Today',
    link: 'https://www.healthcarebusinesstoday.com/employer-health-plans-2026-innovation/'
  },
  {
    image: 'NewsImages/benefits-pro.png',
    title: 'Predictions for 2025 Healthcare Landscape',
    alt: 'Benefits PRO article thumbnail: Predictions for 2025 Healthcare Landscape',
    source: 'Benefits PRO',
    link: 'https://www.benefitspro.com/2024/12/30/the-2025-benefitspro-health-benefits-predictions-almanac-/'
  },
  {
    image: 'NewsImages/medcity-news.png',
    title: 'Improving Outcomes Across the Stop Loss Ecosystem',
    alt: 'Med City News article thumbnail: Improving Outcomes Across the Stop Loss Ecosystem',
    source: 'Med City News',
    link: 'https://medcitynews.com/2025/06/innovative-strategies-to-enhance-financial-predictability-for-self-funded-employers/'
  },
  {
    image: 'NewsImages/pulse-2.0.png',
    title: 'Founder Profile',
    alt: 'PULSE 2.0 article thumbnail: Aegle Capital Founder Profile featuring Gerardo Zampaglione',
    source: 'PULSE 2.0',
    link: 'https://pulse2.com/aegle-capital-profile-gerardo-zampaglione-interview/'
  },
  {
    image: 'NewsImages/RiskandInsurance.png',
    title: 'Adapting Stop Loss Care',
    alt: 'Risk & Insurance article thumbnail: Adapting Stop Loss Care for the Self-Funded Healthcare Ecosystem',
    source: 'Risk & Insurance',
    link: 'https://riskandinsurance.com/a-new-paradigm-for-the-independent-self-funded-healthcare-ecosystem/'
  },
  {
    image: 'NewsImages/healthcare-biz-today.png',
    title: 'Stop-Loss Ecosystem',
    alt: 'Healthcare Business Today article thumbnail: Employer-Sponsored Healthcare and the Stop-Loss Ecosystem',
    source: 'Healthcare Business Today',
    link: 'https://www.healthcarebusinesstoday.com/employer-sponsored-healthcare-2025/'
  },
  {
    image: 'NewsImages/benefitsPRO.png',
    title: 'How to Navigate Soaring SL Rates',
    alt: 'BenefitsPRO article thumbnail: How to Navigate Soaring Stop-Loss Rates',
    source: 'Benefits PRO',
    link: 'https://www.benefitspro.com/2025/09/01/how-to-navigate-soaring-stop-loss-rates/'
  }

];